import { Link } from "../../../shims/useNavigate";

import { PropertyResponse } from "../../../rest/Property";
import { PropsWithChildren } from "react";

import "./Uprn.scss";

interface UprnProps extends PropsWithChildren {
	property?: PropertyResponse;
	propertyId?: string | number;
}

export default function Uprn({ property, propertyId, children }: UprnProps) {
	if (!property && !propertyId) {
		throw new Error("One of property or propertyId must be provided");
	}

	const path = `/epc-data/${property ? property.id : propertyId}`;
	// Remove leading slash
	const linkFrom = window.location.pathname.slice(1);

	return (
		<Link
			to={{
				pathname: path,
				search: `?from=${linkFrom}`,
			}}
			target="_blank"
			rel="noopener noreferrer"
		>
			<span className="uprn">{children}</span>
		</Link>
	);
}
